module.exports = __webpack_public_path__ + "img/D202105_2.f6aaa808.jpg";